<div class="card h-full bg-background">
  @if (isMobile) {
    <button
      class="fixed z-50 top-0 left-0 h-[6vh] w-[6vh] bg-primary-950"
      (click)="menu.toggle($event)"
    >
      <ng-icon name="heroBars3" size="20" color="white"></ng-icon>
    </button>
  }
  <p-menu
    #menu
    [model]="items"
    class="flex justify-center h-full"
    styleClass="w-full md:w-60 h-full"
    [popup]="isMobile"
  >
    <ng-template #start>
      <div class="flex flex-row items-center gap-2 p-2">
        <div
          class="flex items-center justify-center bg-black rounded-[9px] p-1 h-fit w-fit"
        >
          <img src="assets/logo.png" alt="logo" class="w-[40px] h-[40px]" />
        </div>
        <div class="flex flex-col gap-0.5 md:mr-2">
          <h2
            class="!text-[1.8rem] md:!text-[1.5rem] text-dark-text font-bold leading-none trailing-none"
          >
            {{ 'appName' | translate }}
          </h2>
          <p
            class="!text-[1.2rem] md:!text-[1rem] text-light-text font-semibold leading-none trailing-none"
          >
            {{ 'cmsDashboard' | translate }}
          </p>
        </div>
      </div>
    </ng-template>
    <ng-template #submenuheader let-item>
      <span class="text-primary td-strong">{{ item.label | translate }}</span>
    </ng-template>
    <ng-template #item let-item>
      <div class="w-full">
        <a
          [routerLink]="item.routerLink"
          [routerLinkActive]="['link-active']"
          class="link !px-4"
        >
          <ng-icon [name]="item.icon"></ng-icon>
          <span class="ml-2">{{ item.label | translate }}</span>
          @if (item.badge) {
            <p-badge class="ml-auto" [value]="item.badge" />
          }
          @if (item.shortcut) {
            <span
              class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1"
              >{{ item.shortcut }}</span
            >
          }
        </a>
      </div>
    </ng-template>
    <ng-template #end>
      <div class="w-full flex flex-row-items-center justify-center">
        <button
          class="flex flex-row items-center gap-2 w-fit md:w-full px-3 py-1 md:px-2 md:py-1 rounded-md cursor-pointer group text-light hover:text-light-hover hover:bg-[var(--p-menu-item-focus-background)] transition-all duration-200"
          (click)="onLogout()"
        >
          <ng-icon name="heroArrowRightStartOnRectangle" size="20" />
          <span>{{ 'sidebar.signOut' | translate }}</span>
        </button>
      </div>
    </ng-template>
  </p-menu>
</div>
